var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ModalBackdrop, ModalContent } from './styles';
var CustomPopUp = function (_a) {
    var _b = _a.shown, shown = _b === void 0 ? false : _b, close = _a.close, _c = _a.top, top = _c === void 0 ? '0px' : _c, _d = _a.bottom, bottom = _d === void 0 ? '0px' : _d, _e = _a.left, left = _e === void 0 ? '0px' : _e, _f = _a.right, right = _f === void 0 ? '0px' : _f, _g = _a.width, width = _g === void 0 ? '150px' : _g, _h = _a.height, height = _h === void 0 ? '100px' : _h, children = _a.children;
    return shown ? (_jsx(ModalBackdrop, __assign({ top: top, bottom: bottom, left: left, right: right, onClick: function () {
            close();
        } }, { children: _jsx(ModalContent, __assign({ width: width, height: height, onClick: function (e) {
                e.stopPropagation();
            } }, { children: children })) }))) : null;
};
export default CustomPopUp;
